export { getSsrMatchMedia } from './ssr';
